import { FEATURE_MAP } from '../constants/featureMap';
import { AssetsResponse } from '../types/assets';
import { FeatureFlags } from '../types/featureFlags';

function assetFormatter(assets: AssetsResponse | null | undefined, featureFlags: FeatureFlags): Record<string, boolean> {
  if (!assets || !assets.userSubscription) {
    return {
      assetsLoaded: true,
      isConnectAvailable: false,
      isYieldAnalysisAvailable: false
    };
  }

  const webFeaturesByUser = featureFlags?.['web.field-view.featuresByUser'];
  const { userSubscription } = assets;
  const { featuresByUser, featuresByUserCountry } = userSubscription;
  const features = webFeaturesByUser ? [...featuresByUser] : [...featuresByUserCountry];

  const isConnectAvailable = features.includes(FEATURE_MAP.connect);
  const isYieldAnalysisAvailable = features.includes(FEATURE_MAP.yieldAnalysis);

  return {
    assetsLoaded: true,
    isConnectAvailable,
    isYieldAnalysisAvailable
  };
}

export function getAvailableFeatures({
  assets: assetData,
  featureFlags }: { assets: AssetsResponse | null | undefined, featureFlags: FeatureFlags }): Record<string, boolean> {
  const assets = assetFormatter(assetData, featureFlags);

  return {
    askFieldView: !!featureFlags?.['web.ask-fieldview-web'],
    dashboard: !!featureFlags?.['web.dashboard'],
    programs: !!featureFlags?.['web.programs-plugin'],
    connect: !!featureFlags?.['web.connect-available-countries'] && !!assets?.isConnectAvailable,
    reports: !!assets?.isYieldAnalysisAvailable,
    inSeason: !!featureFlags?.['web.in-season'],
    operationHub: !!featureFlags?.['web.operation-hub'],
    fuse: !!featureFlags?.['web.fuse'],
    analytics: !!featureFlags?.['data-hub']
  };
}
